module.exports = __webpack_public_path__ + "img/part4-uIcon7.bea13a81.png";